import React, { useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {
  forgetPassword,
  forgetPasswordContainer,
  subtitle1,
  subtitle2,
  subtitle3,
} from "./Login.style";
import { useNavigate, useLocation } from "react-router-dom";
import ButtonLoading from "../components/ButtonLoading";
import Input from "../components/Input";
import { toast } from "react-toastify";
import { getCode } from "../api/code";
import { USER_DATA } from "../utils/constants";
import { updateProfile } from "../api/user";

export default function Validate() {
  let navigate = useNavigate();
  let location = useLocation();

  let from = location.state?.from?.pathname || "/projects";

  const [code, setCode] = useState("");

  const [loading, setLoading] = useState(false);

  const checkCode = async () => {
    setLoading(true);

    getCode(code)
      .then(async (response) => {
        if (response.length === 0) {
          toast.error("Código inválido.");
        } else {
          const user_uuid = JSON.parse(
            localStorage.getItem(USER_DATA) || "{}"
          ).uid;

          await updateProfile(user_uuid, { isValidated: true }).then(() => {
            localStorage.setItem(
              USER_DATA,
              JSON.stringify({
                ...JSON.parse(localStorage.getItem(USER_DATA) || "{}"),
                isValidated: true,
              })
            );
            navigate(from, { replace: true });
          });
        }
      })
      .catch((e) => {
        toast.error("Ocorreu um problema, tente mais tarde.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();

    if (!code) {
      toast.error("Preencha o código.");
      return;
    }

    checkCode();
  };

  return (
    <Grid container component="main" sx={{ height: "100vh" }}>
      <CssBaseline />
      <Grid
        item
        sm={false}
        md={7}
        sx={{
          backgroundImage: `url(${process.env.PUBLIC_URL + "/back-logo.png"})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <Grid item md={5} sx={{ alignSelf: "center" }}>
        <Box
          sx={{
            my: 8,
            mx: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <span style={subtitle1}>Valide sua conta!</span> <br />
            <span style={subtitle2}>
              Entre com o código de acesso para validar sua conta.
            </span>
            <p style={subtitle3}>
              O código não é enviado por e-mail. Fale com a Qazando caso não
              tenha o código.
            </p>
          </Box>

          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{ mt: 1 }}
            style={{ width: 400 }}
          >
            <Input
              title={"Código"}
              placeholder={"Código"}
              value={code}
              onChange={(e) => setCode(e.target.value)}
              required
            />

            <ButtonLoading label="Validar código" loading={loading} />

            <div style={{ ...forgetPasswordContainer, textAlign: "right" }}>
              <Link href="/login" variant="body2" style={forgetPassword}>
                Voltar
              </Link>
            </div>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}
